import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { I18nProvider } from "./i18n";
import { NotificationsProvider } from "./context/NotificationsContext";
import { ProtectedRoute, Splash } from "./components/Shell";
import Races from "./pages/Races";
import RaceDetail from "./pages/RaceDetail";
import Landing from "./pages/Landing";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Onboarding from "./pages/Onboarding";
import Search from "./pages/Pairs";
import PairDetail from "./pages/PairDetail";
import MatchScreen from "./pages/MatchScreen";
import Matches from "./pages/Matches";
import Profile from "./pages/Profile";
import Plan from "./pages/Plan";
import AdminRaces from "./pages/AdminRaces";

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.is_admin ? children : <Navigate to="/profil" replace />;
};

const GuestOnly = ({ children }) => {
  const { user, profile, loading } = useAuth();
  if (loading) return <Splash />;
  if (user) return <Navigate to={profile ? "/recherche" : "/onboarding"} replace />;
  return children;
};

function App() {
  return (
    <I18nProvider>
    <AuthProvider>
        <NotificationsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/courses" element={<Races />} />
          <Route path="/courses/:id" element={<RaceDetail />} />
          <Route path="/inscription" element={<GuestOnly><Signup /></GuestOnly>} />
          <Route path="/connexion" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="/onboarding" element={<ProtectedRoute requireProfile={false}><Onboarding /></ProtectedRoute>} />
          <Route path="/recherche" element={<ProtectedRoute><Search /></ProtectedRoute>} />
          <Route path="/athlete/:id" element={<ProtectedRoute><PairDetail /></ProtectedRoute>} />
          <Route path="/match/:id" element={<ProtectedRoute><MatchScreen /></ProtectedRoute>} />
          <Route path="/match/:id/plan" element={<ProtectedRoute><Plan /></ProtectedRoute>} />
          <Route path="/admin/courses" element={<ProtectedRoute requireProfile={false}><AdminOnly><AdminRaces /></AdminOnly></ProtectedRoute>} />
          <Route path="/matchs" element={<ProtectedRoute><Matches /></ProtectedRoute>} />
          <Route path="/profil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/signup" element={<Navigate to="/inscription" replace />} />
          <Route path="/login" element={<Navigate to="/connexion" replace />} />
          <Route path="/pairs" element={<Navigate to="/recherche" replace />} />
          <Route path="/profile" element={<Navigate to="/profil" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </NotificationsProvider>
        </AuthProvider>
    </I18nProvider>
  );
}

export default App;
